import { render, staticRenderFns } from "./Incantalia.vue?vue&type=template&id=2c79893a&scoped=true"
import script from "./Incantalia.vue?vue&type=script&lang=js"
export * from "./Incantalia.vue?vue&type=script&lang=js"
import style0 from "./Incantalia.vue?vue&type=style&index=0&id=2c79893a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79893a",
  null
  
)

export default component.exports